module.exports = __webpack_public_path__ + "img/pk.fa938301.png";